/*
 * „WAS IST EINE BUEHNE?" IN ZWEI SAETZEN — Rafael, 03.10.2026 17:16: „Mach es auch mehr
 * selbsterklärend.. Bühne ist für einen Außenstehenden nicht plausibel"; 17:20 entschieden
 * (a): oben im Guide, einmal wegklickbar. Seit 04.10.2026 nur fuer den Admin — Partner haben
 * die lange Karte (GuideErklaerkarte) und sahen sonst zwei Erklaerungen (Rafael: „a — Bei
 * Partnern nur die lange Karte"). GuidePanel blendet sie per istBetreiber aus.
 *
 * Sie verlaengert den Kopf nur, bis sie weggeklickt ist. Gemerkt je Nutzer und Geraet
 * (localStorage) — reine Geraete-Vorliebe, nichts geht an den Server. Ist localStorage
 * gesperrt, gilt das Wegklicken bis zum Neuladen (dann erscheint sie wieder; lieber einmal
 * zu oft erklaert als still verschluckt).
 */
import { useState } from 'react';

export const ERKLAERUNG_MERKER = 'cui-guide-erklaerung-gesehen-v1';
const merker = (userId: string | null | undefined) => `${ERKLAERUNG_MERKER}:${userId || 'ohne-anmeldung'}`;

function gesehen(userId: string | null | undefined): boolean {
  try { return localStorage.getItem(merker(userId)) === 'ja'; } catch { return false; }
}

export default function GuideKurzErklaerung({ userId }: { userId: string | null | undefined }) {
  const [zu, setZu] = useState(() => gesehen(userId));
  if (zu) return null;
  const wegklicken = () => {
    setZu(true);
    try { localStorage.setItem(merker(userId), 'ja'); } catch (e) {
      console.warn(`[guide] Erklaerung weggeklickt, aber nicht gemerkt (localStorage): ${e}`);
    }
  };
  return (
    <div role="note" data-ai-id="guide-kurz-erklaerung" className="guide-kurz-erklaerung">
      <span>
        <b>So funktioniert der Guide:</b> Links stehen deine Themen und offenen Fragen. Rechts zeigt
        die <b>Bühne</b> die Unterlage zu einem Thema — du antwortest meist mit einem Klick.
      </span>
      <button type="button" data-ai-id="guide-kurz-erklaerung-verstanden" onClick={wegklicken}
        title="Erklärung ausblenden — sie kommt auf diesem Gerät nicht wieder" aria-label="Verstanden, Erklärung ausblenden">
        Verstanden ✕
      </button>
    </div>
  );
}
